import i18next from 'core/i18n';
import { RoleNames } from 'shared/constants';

export const rolesInvolved = (roles?: string[]) =>
  roles
    ?.filter(role => role !== RoleNames.FINANCING_ADMIN_SYSTEM)
    .map((role: string) => i18next.t(role))
    .join(', ');
